






















































































import {Component, Mixins} from 'vue-property-decorator';
import MethodMixin from '@/components/claim/mixins/ExchangeProductMethodsMixin.ts';
import PageSizeData from '@/components/board/mixins/PageSizeData';
import SlotPanel from '@/components/claim/mixins/ExchangeProductSlotPanel.vue';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import PageFormBtn from '@/components/board/common/PageFormBtn.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue'
import ProductListCateCascade from '@/components/product/ProductListCateCascade.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import PageContentBottom from '@/components/board/common/PageBottomContent.vue';
import ExchangeProductSlotRight from '@/components/claim/mixins/ExchangeProductSlotRight.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {addClass} from '@/utils/classUtils';
@Component({
  components: {
    SlotPanel,
    PageFormSelect,
    PageFormBtn,
    CompSelectBox,
    ProductListCateCascade,
    CompRadioButton,
    PageContentBottom,
    ExchangeProductSlotRight,    
    ItemTable
  }
  })
export default class ExchangeProduct extends Mixins(MethodMixin, PageSizeData) {
  public popupResize(): void {
    let contentWidth = $('#container').width() + 30;
    let contentHeight = $('#container').height() + 76;
    window.resizeTo(contentWidth, contentHeight);
  }

  public mounted() {
    addClass(document.body, 'popup popup_large');
    setTimeout(() => {this.popupResize()},1000)
  }
}
